'use client'

import React, { useRef } from 'react'
import { cn } from "@/lib/utils"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import type { Swiper as SwiperType } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react"

type ClientSideSwiperProps = {
    children: React.ReactNode
}

export default function ClientSideSwiper({ children }: ClientSideSwiperProps) {
    const swiperRef = useRef<SwiperType>();

    const navigationPrev = () => {
        return (
            <div
                className="w-9 h-9 rounded-full hidden md:flex items-center justify-center bg-white border cursor-pointer absolute -left-5 top-1/2 transform -translate-y-1/2 z-10"
                onClick={() => swiperRef.current?.slideNext()}
            >
                <ChevronLeftIcon className="w-5 h-5 text-gray-400" />
            </div>
        )
    }

    const navigationNext = () => {
        return (
            <div
                className="w-9 h-9 rounded-full hidden md:flex items-center justify-center bg-white border cursor-pointer absolute right-5 top-1/2 transform -translate-y-1/2 z-10"
                onClick={() => swiperRef.current?.slidePrev()}
            >
                <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            </div>
        )
    }

    return (
        <>
            <Swiper
                modules={[Navigation]}
                onBeforeInit={(swiper) => {
                    swiperRef.current = swiper;
                }}
                spaceBetween={0}
                breakpoints={{
                    300: {
                        slidesPerView: 1.8,
                    },
                    400: {
                        slidesPerView: 2,
                    },
                    500: {
                        slidesPerView: 2.2,
                    },
                    750: {
                        slidesPerView: 4,
                    },
                }}
                dir="rtl"
                className={cn("w-full rounded-xl m-0")}
            >
                {React.Children.map(children, (child) => (
                    <SwiperSlide>{child}</SwiperSlide>
                ))}
            </Swiper>
            {navigationPrev()}
            {navigationNext()}
        </>
    )
}